import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';

import ActionsButtons from '@/modules/Settlements/components/Details/shared/Header/ActionsButtons';
import { ISettlements } from '@/modules/Settlements/types';
import { Typography } from '@/shared/components/atoms';
import { SETTLEMENT_STATUS } from '@/shared/constant/backendStatus';

interface Props {
  status?: ISettlements.ISettlementsStatus;
}
const Header: FC<Props> = ({ status }) => {
  const { t } = useTranslation('common');
  const { query } = useRouter();
  const { id } = query;
  const statusBgColor = status ? SETTLEMENT_STATUS[status].color : '';
  const statusTextColor = status ? SETTLEMENT_STATUS[status].textColor : '';
  const statusLabel = (status && SETTLEMENT_STATUS[status]?.label) || '-';

  return (
    <div className='flex items-center justify-between'>
      {/* ************************title********************** */}
      <div className='flex gap-12'>
        <Typography variant='h2' weight='bold'>
          {t('settlement')} {id}
        </Typography>
        <span
          className='flex  items-center justify-center rounded-lg px-16'
          style={{
            backgroundColor: statusBgColor,
            color: statusTextColor,
          }}
        >
          <Typography
            variant='caption'
            weight='bold'
            className='whitespace-nowrap'
          >
            {t(statusLabel)}
          </Typography>
        </span>
      </div>
      {/* ************************actions********************** */}

      <ActionsButtons status={status} />
    </div>
  );
};
export { Header };
